import { z } from "zod";
const schemaStorageSetParams = z.object({
    key: z.string(),
    value: z.string(),
    storeId: z.string().optional(),
});
const schemaStorageSetResults = z.void();
export const schemaStorageSet = {
    params: schemaStorageSetParams,
    result: schemaStorageSetResults,
};
//# sourceMappingURL=StorageSet.js.map